import { useQuery } from '@apollo/client';
import { GET_MY_PERMISSIONS } from '../apollo/queries';

// Answers whether the signed-in user's group may use a governed admin UI region.
//
// The two defaults point in opposite directions, deliberately:
//   - loading returns denied, so a gated region does not flash in and then disappear;
//   - an error or a missing row returns granted, because this package and the api are
//     published independently and an admin bundle can legitimately run against an api
//     that does not serve getMyPermissions yet. Treating "no answer" as a denial would
//     hide the region for every user of every installation that upgraded the admin first.
//
// Neither default is a security control. This gates a UI surface, not data.
function usePermission(resource, action) {
  const { loading, error, data } = useQuery(GET_MY_PERMISSIONS, {
    variables: { resources: [resource] },
    skip: !resource || !action,
    fetchPolicy: 'cache-first'
  });

  if (!resource || !action) return false;
  if (loading) return false;
  if (error) return true;
  if (!data || !data.getMyPermissions) return true;

  const permission = data.getMyPermissions.find(
    ({ resource: permissionResource, action: permissionAction }) =>
      permissionResource === resource && permissionAction === action
  );

  return permission ? permission.granted : true;
}

export default usePermission;
